import { Component, OnInit, Input } from '@angular/core';
import { StorageService } from '../../../_services/storage.service';
@Component({
  selector: 'app-blocco-galleria',
  templateUrl: './blocco-galleria.component.html',
  styles: []
})
export class BloccoGalleriaComponent implements OnInit {

  constructor(private storage: StorageService) { }

  @Input() foto: any[];
  @Input() campi;
  @Input() painted = false;

  openFotoIndex;

  ngOnInit() {
  }



}
